import React from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

const Footer = (props) => {
  return (
    <>
      <footer
      // onMouseEnter={props.mouseEnterOnBlack}
      // onMouseLeave={props.mouseLeaveOnBlack}
      >
        <div
          className="parentFooterEmailSection"
          onMouseEnter={(e) => {
            e.stopPropagation();
            props.mouseEnterOnFooter();
          }}
          onMouseLeave={(e) => {
            e.stopPropagation();
            props.mouseLeaveOnFooter();
          }}
        >
          <div className="content_container footerEmailSection">
            <div className="footerHead">
              <h3 className="colorlightWhite fw-800">
                <span>Starting a new project or</span>
              </h3>
              <h3 className="colorlightWhite fw-800 footer_lets_talk">
                <span>Want to create an impact on your business?</span>{" "}
                <a href="/contact-us" className="unsetAll">
                  <span className="colorYellow">Let’s Connect</span>
                  <Icon icon="uim:angle-right" className="colorYellow"/>
                </a>
              </h3>

              <h3 className="colorlightWhite fw-800 footer_mail_heading">
                Or mail us at <br />
                <a
                  href="mailto:contact@reversethought.com"
                  className="unsetAll"
                >
                  contact@reversethought.com
                </a>
              </h3>
            </div>
          </div>
        </div>

        <div
          className="parentMainFooterContent"
          onMouseEnter={props.mouseEnterOnRed}
          onMouseLeave={props.mouseLeaveOnRed}
        >
          <div className="content_container">
            <div className="row m-0 footerDetails">
              <div className="col-5 col-sm-4 col-md-3 p-0">
                <img
                  src="/images/icons/RT_NewFooterLogo.png"
                  alt="rt-footer-logo"
                  width="80%"
                />
                <h4
                  className="colorWhite fw-800"
                  onMouseEnter={props.onMouseEnterSmall}
                  onMouseLeave={props.onMouseLeaveSmall}
                >
                  We’re your Design <br /> Multiverse
                </h4>
              </div>
              <div className="col-12 col-sm-12 col-md-6 p-0 footer_link_area">
                <div className="footer_nav_links">
                  <ul>
                    <li className="title colorWhite fw-800">Company</li>
                    <a
                      href="/"
                      className="unsetAll"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      Home
                    </a>
                    <a
                      href="/services"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      Services
                    </a>
                    <a
                      href="/works"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      Our Works
                    </a>
                    <a
                      href="/clients"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      Clients
                    </a>
                    <a
                      href="/about-us"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      About Us
                    </a>
                  </ul>
                </div>
                <div className="footer_nav_links">
                  <ul>
                    <li className="title colorWhite fw-800">Services</li>
                    <a
                      href="/website-and-mobile/"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      Web/App
                    </a>
                    <a
                      href="/video-production/"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      Video Production
                    </a>
                    <a
                      href="/digital-marketing/"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      Digital Marketing
                    </a>
                    <a
                      href="/Creative-Services"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      Creative Design
                    </a>
                    <a
                      href="/Digital-Activation-Services"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      Digital Activations
                    </a>
                    <a
                      href="/still-photography/"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      Photography
                    </a>
                  </ul>
                </div>
                <div className="footer_nav_links">
                  <ul>
                    <li className="title colorWhite fw-800">Quick Links</li>
                    {/* 
                    <a href="https://lime-echidna-325677.hostingersite.com/" className="unsetAll"
                    */}
                    <a href="https://www.reversethought.com/blogs/" className="unsetAll"
                      // onClick={() => wndow.scrollTo(0, 0)}
                    >
                      Blogs
                    </a>
                    {/* <a
                      href="/careers"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      News
                    </a> */}
                    <a
                      href="/careers"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      Careers
                    </a>

                    <a
                      href="/contact-us"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      Contact Us
                    </a>

                    <a
                      href="/search-by-location"
                      className="unsetAll"
                      // onClick={() => window.scrollTo(0, 0)}
                    >
                      Search By Location
                    </a>

                  </ul>
                </div>
                <div className="footer_nav_links">
                  <ul>
                    <li className="title colorWhite fw-800">Connect</li>
                    <a
                      href="https://www.instagram.com/reversethought/"
                      target="_blank"
                      className="unsetAll"
                    >
                      Instagram
                    </a>
                    <a href="https://www.linkedin.com/company/reverse-thought" className="unsetAll" target="_blank">
                      Linkedin
                    </a>
                    <a href="https://www.facebook.com/rtcspl/" className="unsetAll" target="_blank">
                      Facebook
                    </a>
                    <a href="https://www.youtube.com/tusharargarg" className="unsetAll" target="_blank">
                      Youtube
                    </a>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-3 p-0 footerDetails4">
                <p className="colorWhite fw-300">
                  Sign up for update, insights, case studies and much more
                </p>
                <p className="colorWhite fw-300">No promotions and spamming</p>
                <form>
                  <input
                    type="text"
                    placeholder="Your Email"
                    className="colorWhite fw-300 w-100"
                    required
                  />
                  <br />
                  <button type="submit" className="unsetAll colorYellow">
                    <span className="colorYellow fw-400 commonViewAll">
                      Get in touch
                    </span>
                    <Icon icon="clarity:arrow-line" className="colorYellow"/>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div
          className="parentCopyRightarea"
          onMouseEnter={props.mouseEnterOnRed}
          onMouseLeave={props.mouseLeaveOnRed}
        >
          <div className="content_container">
            <div className="footerEnd">
              <p className="colorWhite fw-200">
                © Copyright 2024 &nbsp;&nbsp;| &nbsp; &nbsp; Reverse Thought
                Creative Studio Pvt. Ltd. &nbsp;&nbsp; | &nbsp;&nbsp; All Rights
                Reserved.
              </p>
              <ul>
                <li>
                  {" "}
                  <a
                    className=" colorWhite fw-200 text-decoration-none "
                    href="/faq"
                  >
                    FAQs{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    className=" colorWhite fw-200 text-decoration-none "
                    href="/privacy-policy"
                  >
                    Privacy Policy{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    className=" colorWhite fw-200 text-decoration-none "
                    href="/terms-of-use"
                  >
                    Terms of Use{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    className=" colorWhite fw-200 text-decoration-none "
                    href="/sitemap"
                  >
                    Sitemap{" "}
                  </a>{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* </div> */}
      </footer>
    </>
  );
};

export default Footer;
